export default function current_store_data(state = false, action) {
    switch (action.type) {
        case 'CURRENT_STORE_DATA_SET':
            return action.payload
        default:
            return state
    }
} 